import { compose, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'

import { redirectTo } from './redirect'

// logger middleware
const logger = store => next => action => {
  console.group(action.type)
  console.log('dispatching', action)
  let result = next(action)
  console.log('next state', store.getState())
  console.groupEnd(action.type)
  return result
}

/**
 * Lets you dispatch promises in addition to actions.
 * If the promise is resolved, its result will be dispatched as an action.
 * The promise is returned from `dispatch` so the caller may handle rejection.
 */
const vanillaPromise = store => next => action => {
  if (typeof action.then !== 'function') {
    return next(action)
  }

  return Promise.resolve(action).then(store.dispatch)
}

/**
 * Lets you dispatch redirect actions: {type: 'redirect', to: '#login'}
 */
const routing = store => next => action => {
  if (action.type == 'redirect') {
    return redirectTo(action.to)
  }
  return next(action)
}

let middlewares = [routing, thunk, vanillaPromise]
if (__DEV__) middlewares.push(logger)

let enhancer = applyMiddleware(...middlewares)
// use dev tools extension
if (__DEV__) if (window.devToolsExtension) {
  enhancer = compose(
    enhancer,
    window.devToolsExtension()
  )
}

export default (preloadedState) => {
  const store = createStore(rootReducer, preloadedState, enhancer)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducer', () => {
      const nextReducer = require('./reducer').default
      store.replaceReducer(nextReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/app/store.js